import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import ReactMarkdown from "react-markdown"

const ComponentName = ({ data }) => {
  const { content } = data.blog
  return (
      <Layout>
        <section className="blog-template">
          <div classname="section-center">
            <article classname="blog-content">
              <ReactMarkdown source={content} />
              <Link to="/blog" className="btn center-btn">blog</Link>
            </article>
          </div>
        </section>
      </Layout>
  )
}

export const query = graphql`
  query GetSingleBlog($slug: String) {
    blog: strapiBlogs(slug: { eq: $slug }) {
      content

    }
  }
`

export default ComponentName
